import { MarkdownContent } from "@js/components/markdown-content";
import type { OfferCommon } from "@js/types/jobs";

import { InfoRow } from "./info-row";
import { OfferPreviewSectionContainter } from "./section-container";

type AdditionalTermsProps = {
  offer: OfferCommon;
};

export const AdditionalTerms = ({ offer }: AdditionalTermsProps) => {
  const showAdditionalTerms = !!offer.additional_contract_terms;
  if (!showAdditionalTerms) {
    return <></>;
  }

  return (
    <OfferPreviewSectionContainter title="📑 Additional terms">
      <InfoRow
        label={<MarkdownContent markdown={offer.additional_contract_terms} />}
      />
    </OfferPreviewSectionContainter>
  );
};
